(function($){
	var winWidth = $(window).width();
	if(winWidth > 1900) {
		var titleHeight = $('.post-header').height();
		var titlePadding = parseInt($('.post-header').css('padding-bottom').replace('px', ''));
		var metaHeight = $('.post-meta').outerHeight();
		$('.event-content').height(titleHeight + titlePadding + metaHeight - 8);	
	}
})(jQuery);